<app-header class="header" />

<main class="shell-container-row main">
  <div class="main-content">
    <ng-content />
  </div>
</main>

<app-footer [systemInfo]="systemInfo$ | async" [customerSpace]="checkedCustomerSpace()" />

<app-notification-drawer [customerSpaceId]="checkedCustomerSpace()?.id" />
